export default __webpack_public_path__ + "navigation-examples-route-alerts-1200-71f428b1d7589509ed01d69a7b684355.webp";